var _ellipse, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _circle, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPostTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 138,
    viewBox: "0 0 148 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 68.9109,
    rx: 69,
    ry: 68.9109,
    fill: "url(#paint0_linear_11864_57526)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3311 14.8218L78.6778 15.7347V21.99H70.5076L70.3311 14.8218Z",
    fill: "#8E9EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.133 17.1082L14.2609 18.4573C13.0122 18.476 12.0152 19.5034 12.0339 20.7521L13.352 108.561C13.3708 109.81 14.3982 110.807 15.6468 110.788L105.519 109.439C106.768 109.42 107.765 108.393 107.746 107.144L106.428 19.3351C106.409 18.0865 105.382 17.0895 104.133 17.1082Z",
    fill: "#5E6974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.667 15.9863L15.3917 17.3264C14.1431 17.3452 13.1461 18.3726 13.1648 19.6212L14.4829 107.43C14.5016 108.679 15.5291 109.676 16.7777 109.657L106.053 108.317C107.302 108.298 108.299 107.271 108.28 106.022L106.962 18.2132C106.943 16.9646 105.916 15.9676 104.667 15.9863Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.332,
    y: 43.0928,
    width: 75.1922,
    height: 33.8122,
    rx: 1.13056,
    transform: "rotate(-0.866421 23.332 43.0928)",
    fill: "#BDC3C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.332,
    y: 84.7192,
    width: 75.1922,
    height: 4.17591,
    rx: 1.13056,
    transform: "rotate(-0.866421 23.332 84.7192)",
    fill: "#BDC3C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.332,
    y: 96.7134,
    width: 75.1922,
    height: 4.17591,
    rx: 1.13056,
    transform: "rotate(-0.866421 23.332 96.7134)",
    fill: "#BDC3C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6553,
    y: 28.6045,
    width: 14.2651,
    height: 4.17591,
    rx: 1.13056,
    transform: "rotate(-0.866421 43.6553 28.6045)",
    fill: "#BDC3C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7845,
    cy: 30.0843,
    r: 6.2181,
    fill: "#8E9EAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3311 14.8218L98.3248 14.8948C98.3248 14.8948 98.4162 14.8218 103.117 17.9654V73.611L89.658 64.3983L75.6051 73.611V17.9654L70.3311 14.8218Z",
    fill: "#8E9EAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.775 93.0397L147.828 90.314L140.937 87.651L138.133 79.8218L135.398 87.4549L128 90.314L135.56 93.2358L138.133 100.416L140.775 93.0397Z",
    fill: "#BDC3C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11864_57526",
    x1: 53.931,
    y1: -234.455,
    x2: 68.9611,
    y2: 192.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPostTopics);
export default __webpack_public_path__ + "static/media/no-post-topics.0811ce6eee28b3faded8f85357f895b2.svg";
export { ForwardRef as ReactComponent };